const prefix = "FLIGHT_EDIT";
const createActionTypes = (resource) => ({
  LOAD: `${prefix}/${resource}/LOAD'`,
  LOADING: `${prefix}/${resource}/LOADING'`,
  LOADED: `${prefix}/${resource}/LOADED'`
});
const updateFlightAction = "UPDATE_FLIGHT";
const updateFlightActionTypes = {
  UPDATE: `${prefix}${updateFlightAction}/UPDATE`,
  UPDATING: `${prefix}${updateFlightAction}/UPDATING`,
  UPDATED: `${prefix}${updateFlightAction}/UPDATED`,
  CANCEL_UPDATE: `${prefix}${updateFlightAction}/CANCEL_UPDATE`,
  NAVIGATE_TO_DETAILS: `${prefix}${updateFlightAction}/NAVIGATE_TO_DETAILS`,
  NAVIGATED_TO_DETAILS: `${prefix}${updateFlightAction}/NAVIGATED_TO_DETAILS`
};
const updateFlight = (flightId, workspaceId, managementGroup, configuration) => {
  return {
    type: updateFlightActionTypes.UPDATE,
    payload: {
      flightId,
      workspaceId,
      managementGroup,
      configuration
    }
  };
};
const updatingFlight = (payload) => {
  return {
    type: updateFlightActionTypes.UPDATING,
    payload
  };
};
const updatedFlight = (payload, result) => {
  return {
    type: updateFlightActionTypes.UPDATED,
    payload: { result, workspaceId: payload.workspaceId, managementGroup: payload.managementGroup, flightId: payload.flightId }
  };
};
const cancelEdit = (flightId) => {
  return {
    type: updateFlightActionTypes.CANCEL_UPDATE,
    payload: { flightId }
  };
};
const navigateToDetails = (flightId, workspaceId, managementGroup) => {
  return {
    type: updateFlightActionTypes.NAVIGATE_TO_DETAILS,
    payload: { flightId, workspaceId, managementGroup }
  };
};
const navigatedToDetails = () => {
  return {
    type: updateFlightActionTypes.NAVIGATED_TO_DETAILS,
    payload: {}
  };
};
const loadPathsActionTypes = createActionTypes("LOAD_PATHS");
const loadManagementGroupPaths = (flightId, workspaceId, tenant) => {
  return {
    type: loadPathsActionTypes.LOAD,
    payload: {
      flightId,
      workspaceId,
      tenant
    }
  };
};
const loadingManagementGroupPaths = (payload) => {
  return {
    type: loadPathsActionTypes.LOADING,
    payload: { flightId: payload.flightId }
  };
};
const loadedManagementGroupPaths = (flightId, paths) => {
  return {
    type: loadPathsActionTypes.LOADED,
    payload: {
      flightId,
      paths
    }
  };
};
export {
  cancelEdit,
  createActionTypes,
  loadManagementGroupPaths,
  loadPathsActionTypes,
  loadedManagementGroupPaths,
  loadingManagementGroupPaths,
  navigateToDetails,
  navigatedToDetails,
  updateFlight,
  updateFlightActionTypes,
  updatedFlight,
  updatingFlight
};
//# sourceMappingURL=FlightEdit.ducks.js.map
